import { Inject, Injectable } from '@angular/core';
import { FirebaseApp } from 'angularfire2';
import { AngularFireDatabase, AngularFireList, AngularFireObject } from 'angularfire2/database';

import { Observable } from 'rxjs/Observable';

import { Kursant } from './kursant';
import { Grupa } from './grupa';
import { KursantGrupa } from './kursant-grupa';
import firebaseUpdate from './firebase/firebaseUpdateToObs';
import { DeleteKursantRequest } from './delete-kursant-request';

@Injectable()
export class KursanciService {

    dbRef: any;

    constructor(private af: AngularFireDatabase, @Inject(FirebaseApp) dbRef) {
        this.dbRef = dbRef.database().ref();
    }

    getKursanci(): AngularFireList<Kursant> {
        return this.af.list('/kursanci', ref => ref
            .orderByChild('isActive')
            .equalTo(true)
        )
    }

    getAktywneGrupy(isArchiv: number): AngularFireList<Grupa[]> {
        return this.af.list<Grupa[]>('/kursy', ref => ref
            .orderByChild('isArchiv')
            .equalTo(isArchiv)
        )
    }

    findKursantByKey(key: string): AngularFireObject<Kursant> {
        return this.af.object<Kursant>('kursanci/'  + key)
    }

    findGrupaByKey(key: string): AngularFireObject<Grupa> {
        return this.af.object<Grupa>('kursy/' + key)
    }

    dodajKursanta(kursant: any): Observable<any> {

        const kursantDoDodania = Object.assign({}, kursant);
        const newKursantKey = this.dbRef.child('kursanci').push().key;
        let daneDoDodania = {};

        daneDoDodania["kursanci/" + newKursantKey] = kursantDoDodania;

        return firebaseUpdate(this.dbRef, daneDoDodania);
    }

    updateKursant(kursant: Kursant): Observable<Kursant>  {
        const oldKursant = this.dbRef.find(k => k.key === kursant.key);
        const newKursant = Object.assign(oldKursant, kursant); // Demo: mutate cached hero
        return firebaseUpdate(this.dbRef, newKursant);
    }

    dodajKursantaDoGrupy(grupaId: string, kursant: any): Observable<any> {

        const kursantDoDodania = Object.assign({}, kursant, {grupaId});
        const newKursantKey = this.dbRef.child('kursanci').push().key;
        let daneDoDodania = {};

        daneDoDodania["kursanci/" + newKursantKey] = kursantDoDodania;
        daneDoDodania[`kursanci_kursy/${grupaId}/${newKursantKey}`] = true;

        return firebaseUpdate(this.dbRef, daneDoDodania);
    }

    zapiszKursanta(kursantId: string, kursant): Observable<any> {

        const kursantDoDodania = Object.assign({}, kursant);
        delete(kursantDoDodania.$key);
        let daneDoDodania = {};

        daneDoDodania[`kursanci/${kursantId}`] = kursantDoDodania;

        return firebaseUpdate(this.dbRef, daneDoDodania);
    }

    dodajGrupe(grupa: any): Observable<any> {

        const grupaDoDodania = Object.assign({}, grupa);
        const newGrupaKey = this.dbRef.child('kursy').push().key;
        let daneDoDodania = {};

        daneDoDodania["kursy/" + newGrupaKey] = grupaDoDodania;

        return firebaseUpdate(this.dbRef, daneDoDodania);
    }

    dodajGrupeDoKursanta(kursantId: string, grupa: any): Observable<any> {

        const grupaDoDodania = Object.assign({}, grupa, {kursantId});
        const newGrupaKey = this.dbRef.child('kursy').push().key;
        let daneDoDodania = {};

        daneDoDodania["kursy/" + newGrupaKey] = grupaDoDodania;
        daneDoDodania[`kursanci_kursy/${kursantId}/${newGrupaKey}`] = true;

        return firebaseUpdate(this.dbRef, daneDoDodania);
    }

    zapiszGrupe(grupaId: string, grupa): Observable<any> {

        const grupaDoDodania = Object.assign({}, grupa);
        delete(grupaDoDodania.$key);
        let daneDoDodania = {};

        daneDoDodania[`kursy/${grupaId}`] = grupaDoDodania;

        return firebaseUpdate(this.dbRef, daneDoDodania);
    }

    requestLessonDeletion(kursantId: string, grupaId: string) {
        this.dbRef.child('queue/tasks').push(new DeleteKursantRequest(kursantId, grupaId))
            .then(
                () => alert('Usuwam kursanta!')
            );
    }

}



// WEBPACK FOOTER //
// ./src/app/services/kursanci.service.ts